import { render } from "./HarpiaAboutModal.vue?vue&type=template&id=134cbad0&scoped=true"
import script from "./HarpiaAboutModal.vue?vue&type=script&lang=js"
export * from "./HarpiaAboutModal.vue?vue&type=script&lang=js"

import "./HarpiaAboutModal.vue?vue&type=style&index=0&id=134cbad0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134cbad0"]])

export default __exports__